var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9338 17.2206C25.1886 9.52596 21.5511 7.47755 20.6232 6.02954C20.2406 5.39165 19.9016 4.72859 19.6086 4.04492C19.5596 4.72849 19.4696 5.15913 18.8882 5.6775C17.7209 6.71766 12.7634 10.7552 12.3461 19.498C11.9574 27.6495 18.3422 32.676 19.1857 33.1955C19.8343 33.5145 20.6243 33.2023 21.0096 32.9095C24.0874 30.7985 28.2926 25.1705 26.9373 17.2206",
    fill: "#10AA50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8754 28.8555C19.7146 30.8731 19.5995 32.0454 19.1914 33.1984C19.1914 33.1984 19.4593 35.1192 19.6474 37.1539H20.3131C20.4719 35.7211 20.7144 34.2988 21.0392 32.8942C20.1774 32.4704 19.9084 30.6259 19.8754 28.8555Z",
    fill: "#B8C4C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.037 32.8954C20.1661 32.4932 19.9142 30.61 19.8754 28.8555C20.0908 25.9614 20.1536 23.0579 20.0635 20.1572C20.0179 18.6351 20.0852 6.05981 19.6885 4.21875C19.9598 4.8423 20.2725 5.44708 20.6244 6.02905C21.5523 7.47821 25.1909 9.52662 26.935 17.2213C28.2938 25.1574 24.1114 30.7706 21.037 32.8954Z",
    fill: "#12924F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.e45f7f4888b4e3f013bbab3d550552eb.svg";
export { ForwardRef as ReactComponent };